import { FormSection, IFormField, JsonItem} from "../web-form/web-form.objects";
import _ from "lodash";

export class EditModal {
    editModalId: string;
    formSections: FormSection[];
    saveFn: (items: any[], isAdd: boolean) => Promise<string>;

    isAdd: boolean;
    displayPropertyName: string;
    displayPropertyFn: (item: any, pickLists: JsonItem[]) => string;
    modalTitle: string;
    modalSubtitleFn: (items: any[], pickLists: JsonItem[]) => string;
    saveBtnText: string;

    isScrolling: boolean; // used to avoid 'stacking' scrolls
    currentItems: any[];
    pickLists: JsonItem[];
    constructor(config: EditModalConfig) {
        this.editModalId = config.editModalId;
        this.formSections = config.formSections;
        this.saveFn = config.saveFn;

        this.isAdd = true;
        if (config.isAdd === false) { this.isAdd = false; }

        this.modalTitle = "Add";
        if (config.modalTitle) { this.modalTitle = config.modalTitle }
        else if (!this.isAdd) { this.modalTitle = "Edit" };

        this.modalSubtitleFn = (): string => "";
        if (config.modalSubtitleFn) { this.modalSubtitleFn = config.modalSubtitleFn; }

        this.displayPropertyName = "Id";
        if (config.displayPropertyName) { this.displayPropertyName = config.displayPropertyName }
        this.displayPropertyFn = (): string => "";
        if (config.displayPropertyFn) { this.displayPropertyFn = config.displayPropertyFn; }

        this.saveBtnText = "+ Add";
        if (config.saveBtnText) { this.saveBtnText = config.saveBtnText }
        else if (!this.isAdd) { this.saveBtnText = "Save" }

        this.isScrolling = false;
        this.currentItems = [];
        this.pickLists = [];
    }

    openModal(items: any[], pickLists: JsonItem[] = [], sectionId: string = ""): void {
        this.currentItems = items;
        this.pickLists = pickLists;

        this.generateModalHtml();
        this.initializeModalForm();
        this.initializeModal();

        $(`#${this.editModalId}`).modal("show");

        // Scroll to Target
        if (sectionId) {
            setTimeout(() => {
                this.isScrolling = false;
                this.scrollToSection(sectionId);
            }, 250)
        }
    }

    showSaving(isSaving: boolean = true): void {
        let modal = $(`#${this.editModalId}`);
        let modalContent = modal.find(".modal-content");
        let modalSaving = modal.find(".modal-saving");

        if (isSaving) {
            this.showSaved(false);
            // Hide modal content, show saving display
            modalSaving.removeClass("d-none");
            modalContent.addClass("d-none");
        }
        else {
            modalSaving.addClass("d-none");
            modalContent.removeClass("d-none");
        }
    }

    showSaved(isSaved: boolean = true): void {
        let modal = $(`#${this.editModalId}`);
        let modalSaving = modal.find(".modal-saving");
        let savingDisplay = modalSaving.find(".saving-display");
        let savedDisplay = modalSaving.find(".saved-display");

        if (isSaved) {
            // Show 'Saved' text
            savingDisplay.addClass("d-none");
            savedDisplay.removeClass("d-none");
        }
        else {
            // Show 'Saving' text
            savingDisplay.removeClass("d-none");
            savedDisplay.addClass("d-none");
        }
    }

    private generateModalHtml(): void {
        let closeRow = `
            <div class="edit-item-modal-close-row">
                <div class="d-flex justify-content-end">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
                    </button>
                </div>
            </div>
        `;

        let changeHeader = "";
        let selectedRow = "";
        if (!this.isAdd) {
            changeHeader = `
                <div class="edit-item-changes-block">
                    <div class="expand-changes-btn">
                        <span class="d-inline">
                            <i class="fa-solid fa-chevron-left pr-2 open-changes-icon"></i>
                            Changes
                            <i class="fa-solid fa-chevron-right pr-2 close-changes-icon"></i>
                        </span>
                    </div>
                </div>
            `;

            selectedRow = `
                <div class="edit-item-subtitle">
                    ${this.currentItems.length} Selected
                </div>
            `;
        }
        
        let modalSubtitle = this.modalSubtitleFn(this.currentItems, this.pickLists);
        if (modalSubtitle) {
            selectedRow = `
                <div class="edit-item-subtitle">
                    ${modalSubtitle}
                </div>
            `;
        }


        let headerRow = `
            <div class="edit-item-modal-header-row">
                <div class="d-flex" style="flex-direction: row-reverse;">
                    ${changeHeader}
                    <div class="col edit-item-overview-block">
                        <div class="edit-item-title ${this.isAdd ? "mt-2" : ""}">
                            ${this.modalTitle}
                        </div>
                        ${selectedRow}
                    </div>
                </div>
            </div>
        `;

        let formSectionBlock = "";

        let verticalTabs = "";
        let formContent = "";
        for (let i = 0; i < this.formSections.length; i++) {
            let currentSection = this.formSections[i];
            verticalTabs += `
                <div class="vertical-tab ${i == 0 ? "active" : ""}" data-section-id="${currentSection.sectionId}">
                    <div class="vertical-tab-text">
                        ${currentSection.displayName}
                    </div>
                </div>
            `;

            let formFields = "";
            currentSection.formFields.forEach(field => {
                formFields += field.generateHtml();
            });

            formContent += `
                <div class="form-section-header ${!currentSection.displayName ? "invisible" : ""}" id="${currentSection.sectionId}-section-header">
                    ${currentSection.displayName}
                </div>
                <div class="form-section-fields">
                    ${formFields}
                </div>
            `;
        }

        if (this.formSections.length <= 1) {
            formSectionBlock = `
                <div class="col-12 form-section">
                    ${formContent}
                </div>
            `
        }
        else {
            formSectionBlock = `
                <div class="form-tabs">
                    <div class="d-flex flex-column vertical-tab-group mb-3">
                        ${verticalTabs}
                    </div>
                </div>
                <div class="form-section">
                    ${formContent}
                </div>
            `;
        }     

        let modalBody = `
            <div class="edit-item-modal-body">
                <div class="edit-item-form-container">
                    ${formSectionBlock}
                </div>
                <div class="edit-item-change-container d-none">
                    <div class="form-change-section">
                    </div>
                </div>
                <div class="edit-item-error-container d-none">
                    
                </div>
            </div>
        `;

        let modalFooter = `
            <div class="edit-item-modal-footer">
                <button class="butn edit-item-save-btn"><span>${this.saveBtnText}</span></button>
            </div>
        `;


        let html = `
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    ${closeRow}
                    ${headerRow}
                    ${modalBody}
                    ${modalFooter}
                </div>

                <div class="modal-saving d-none">
                    <div class="saving-display d-none">
                        <div class="font-size20 font-weight-500 text-center pb-1">
                            Saving
                        </div>
                        <div class="d-flex justify-content-center py-3">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="saved-display d-none">
                        <div class="font-size20 font-weight-500 text-center">
                            Saved!
                        </div>
                    </div>
                </div>
            </div>
        `;

        $(`#${this.editModalId}`).empty().html(html);
    }

    private initializeModal(): void {
        let modal = $(`#${this.editModalId}`);

        // Vertical Tabs
        let vertTabContainer = modal.find(".form-tabs");
        let vertTabs = vertTabContainer.find(".vertical-tab");
        vertTabs.on("click", (e) => {
            let target = $(e.currentTarget);
            let sectionId = $(target).data("sectionId");
            this.scrollToSection(sectionId);
        });

        // Update Tabs on Scroll
        let formSection = modal.find(".form-section");
        formSection.on("scroll", () => {
            let activeTab = vertTabs.first();

            vertTabs.each((_, item) => {
                let targetSectionId = $(item).data("sectionId");
                let targetSection = $(`#${targetSectionId}-section-header`);
                if (!targetSection.length) return;

                let padHeight = 0;
                let sectionTop = targetSection.position().top;
                let targetTop = sectionTop - padHeight;

                if (targetTop <= 0) {
                    activeTab = $(item);
                }
            });

            vertTabs.removeClass("active");
            if (activeTab) {
                activeTab.addClass("active");
            }
        });

        // Save Button
        this.initializeSaveButton();

        // --- Edit Only ---
        if (!this.isAdd) {
            // View Change Log Controls
            let changeBtn = modal.find(".edit-item-changes-block");
            let changeContent = modal.find(".edit-item-change-container");
            let formContent = modal.find(".edit-item-form-container");
            changeBtn.on("click", () => {
                changeBtn.toggleClass("expand");
                if (changeBtn.hasClass("expand")) {
                    changeContent.removeClass("d-none");
                    formContent.addClass("d-none");
                }
                else {
                    changeContent.addClass("d-none");
                    formContent.removeClass("d-none");
                }
            });

            // Change Triggers
            formSection.on("form-field-change", () => {
                this.updateChangeLog();
            })
            this.updateChangeLog();
        }
    }

    private initializeSaveButton() {
        let modal = $(`#${this.editModalId}`);

        // Save Button
        let saveBtn = modal.find(".edit-item-save-btn");

        saveBtn.on("click", async () => {
            let isValid = this.validateForm();

            if (isValid) {
                this.showSaving();

                let updatedItems = this.getUpdatedItems();

                let errorMsg = await this.saveFn(updatedItems, this.isAdd);
                if (errorMsg) {
                    let errorTitle = "Error while Saving";
                    let errorContent = `<p>${errorMsg}</p>`;
                    this.updateErrorBlock(errorTitle, errorContent);
                    this.showErrorBlock();
                    this.showSaving(false);
                }
                else {
                    this.showSaved();

                    // Close Modal
                    setTimeout(() => {
                        modal.modal("hide");
                    }, 1000);
                }            
            }
        });
    }

    getUpdatedItems(): any[] {
        let updatedItems = [];

        this.currentItems.forEach(item => {
            let updatedItem = _.cloneDeep(item);

            this.formSections.forEach(section => {
                section.formFields.forEach(field => {
                    if (this.isAdd) {
                        updatedItem = field.updateItem(updatedItem);
                    }
                    else {
                        if (field.checkValid() && field.checkChanged()) {
                            updatedItem = field.updateItem(updatedItem);
                        }
                    }
                })
            });

            updatedItems.push(updatedItem);
        });

        return updatedItems;
    }

    private validateForm(): boolean {
        let isValid = true;
        let invalidFields: IFormField[] = [];
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.resetValidDisplay();
                let isChanged = field.checkChanged();

                if (isChanged || this.isAdd) {
                    let fieldValid = field.checkValid()
                    if (!fieldValid) {
                        isValid = false;
                        invalidFields.push(field);
                        field.displayValid(fieldValid);
                    }

                    if (isChanged && fieldValid) {
                        field.displayValid(fieldValid);
                    }
                    
                }
            })
        });

        if (isValid) {
            this.showErrorBlock(false);
            return true;
        }

        let errorFieldsDisplay = "";
        invalidFields.forEach(field => {
            errorFieldsDisplay += `<li>${field.displayName}</li>`
        });

        let displayTitle = "Issues Found";
        if (invalidFields.length == 1) {
            displayTitle = "Issue Found";
        }

        let errorTitle = `${invalidFields.length} ${displayTitle}`;
        let errorContentHtml = `
            <p class="mb-1">There's an issue with the fields below. Please update these fields before saving:</p>
            <ul>
                ${errorFieldsDisplay}
            </u>
        `
        
        this.updateErrorBlock(errorTitle, errorContentHtml);
        this.showErrorBlock()

        return false;
    }

    private showErrorBlock(shouldShow: boolean = true): void {
        let modal = $(`#${this.editModalId}`);
        let errorContainer = modal.find(".edit-item-error-container");

        if (shouldShow) {
            errorContainer.removeClass("d-none");
        }
        else {
            errorContainer.addClass("d-none");
        }
    }

    private updateErrorBlock(errorBlockTitle: string, errorBlockHtmlContent: string): void {
        let modal = $(`#${this.editModalId}`);
        let errorContainer = modal.find(".edit-item-error-container");

        let errorBlockContent = `
            <div class="error-block">
                <div class="edit-item-error-content">
                    <div class="col-auto">
                        <i class="fa-solid fa-circle-exclamation error-icon"></i>
                    </div>
                    <div class="col">
                        <div class="error-content-title">${errorBlockTitle}</div>
                        ${errorBlockHtmlContent}
                    </div>
                </div>
                <div class="col-12 pb-3">
                    <button class="edit-item-error-close btn btn-secondary">Hide</button>
                </div>
            </div>
        `;

        errorContainer.empty().html(errorBlockContent);

        let closeBtn = modal.find(".edit-item-error-close");
        closeBtn.on("click", () => {
            errorContainer.addClass("d-none");
        });
    }

    private updateChangeLog(): void {     
        let changedFields: IFormField[] = [];
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                if (field.checkValid() && field.checkChanged()) {
                    changedFields.push(field);
                }
            })
        });

        let changeSection = $(`#${this.editModalId}`).find(".form-change-section");
        let changeHtml = "";

        for (let i = 0; i < this.currentItems.length; i++) {
            let item = this.currentItems[i];

            // Create updated item to compare
            let newItem = _.cloneDeep(item);
            changedFields.forEach(field => {
                newItem = field.updateItem(newItem);
            });

            let title = this.getItemTitle(item);
            if (!title) {
                title = `Item ${i + 1}`;
            }

            let changedContent = ""
            let changeBubbles = "";
            changedFields.forEach(field => {
                let updateContent = field.generateChangeHtml(newItem, item);
                if (updateContent) {
                    changeBubbles += `<div class="change-prop-bubble">${field.displayName}</div>`
                    changedContent += updateContent;
                }
            });
            if (!changedContent) {
                changedContent = "No Change";
                changeBubbles = `<div class="change-prop-bubble no-change">-- No Change --</div>`
            }

            let changeCard = `
                <div class="form-change-card">
                    <div class="collapsed change-card-header" data-toggle="collapse" data-target="#change-card-collapse-${i}">
                        <div class="change-card-title">${title}</div>
                        <div class="change-card-bubbles">
                            ${changeBubbles}
                        </div>
                    </div>
                </div>
                <div id="change-card-collapse-${i}" class="collapse">
                    ${changedContent}
                </div>
            `;

            changeHtml += changeCard;
        }

        changeSection.empty().html(changeHtml);
    }

    private getItemTitle(item: any): string {
        if (this.displayPropertyFn) {
            return this.displayPropertyFn(item, this.pickLists);
        }
        else if (this.displayPropertyName) {
            let title = _.get(item, this.displayPropertyName);
            return title;
        }

        return "";
    }

    private initializeModalForm(): void {
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.setOptions(this.pickLists);
                field.initialize();
            })
        });

        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.prepopulate(this.currentItems);
            })
        })
    }

    scrollToSection(sectionId: string): void {
        let foundSection = this.formSections.find(section => section.sectionId == sectionId);
        if (foundSection && !this.isScrolling) {
            this.isScrolling = true;

            let formSection = $(`#${this.editModalId}`).find(".form-section");

            let targetSection = formSection.find(`#${sectionId}-section-header`);
            if (!targetSection) return;

            let sectionOffset = $(targetSection).position().top;

            let targetOffset = sectionOffset;

            let currentScroll = $(formSection).scrollTop();
            let setScroll = currentScroll + targetOffset;

            if (setScroll < 0) setScroll = 0;

            $(formSection).animate({ scrollTop: setScroll }, 500);
            setTimeout(() => this.isScrolling = false, 500); // allow scrolling after animation
        }
    }
}

export class EditModalConfig {
    editModalId: string; // id of modal target (should already have class "edit-item-modal")
    formSections: FormSection[]; // Contains form sections/fields
    saveFn: (items: any[], isAdd: boolean) => Promise<string>; // method for saving the modal (if value is returned, assume error)

    isAdd?: boolean; // Is for adding New Item (no change log)
    displayPropertyName?: string; // property for display in change log (dot notation)
    displayPropertyFn?: (item: any, pickLists: JsonItem[]) => string; // provide a method for creating a display name for the item in change log
    modalTitle?: string; // specify a name for the title
    modalSubtitleFn?: (items: any[], pickLists: JsonItem[]) => string; // For setting subtext in modal
    saveBtnText?: string; // implicitly set the save text
}